module.exports = __webpack_public_path__ + "static/media/cake.732ed907.png";